module.exports = __webpack_public_path__ + "img/module-58-bg.84f373eb.webp";